import React from "react";
import {
  IBreadcrumbItem,
  Breadcrumb,
} from "office-ui-fabric-react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { NavigationPath } from "../../../../config/routing/NavigationPath";
import { breadcrumbS } from "../../styles/breadCrumb.styles";

const breadcrumbKeyMap = new Map<string, string[]>([
  [NavigationPath.ALL_ORDERS, ["ordersGroup", "allOrders"]],
  [NavigationPath.NEW_ORDERS, ["ordersGroup", "newOrders"]],
  [NavigationPath.ACCEPTED_ORDERS, ["ordersGroup", "acceptedOrders"]],
  [NavigationPath.IN_PROGRESS_ORDERS, ["ordersGroup", "inProgressOrders"]],
  [NavigationPath.COMPLETED_ORDERS, ["ordersGroup", "completedOrders"]],
  [NavigationPath.INVOICED_ORDERS, ["ordersGroup", "invoicedOrders"]],
  [NavigationPath.CANCELED_ORDERS, ["ordersGroup", "canceledOrders"]],
  [NavigationPath.CONTAINERS_VALIDATORS, ["validatorsGroup", "containersValidators"]],
  [NavigationPath.RECEPTION_PLACES_VALIDATORS, ["validatorsGroup", "receptionPlacesValidators"]],
  [NavigationPath.ORDERS_VALIDATORS, ["validatorsGroup", "ordersValidators"]],
  [NavigationPath.DETAILED_PRICE_LIST, ["pricingGroup", "detailedPricelist"]],
  [NavigationPath.GENERAL_PRICE_LIST, ["pricingGroup", "generalPricelist"]],
  [NavigationPath.UNVERIFIED_CLIENTS, ["clientsGroup", "unverifiedClients"]],
  [NavigationPath.ACTIVE_CLIENTS, ["clientsGroup", "activeClients"]],
  [NavigationPath.INACTIVE_CLIENTS, ["clientsGroup", "inactiveClients"]],
  [NavigationPath.RECEPTION_PLACES, ["clientsGroup", "receptionPlaces"]],
  [NavigationPath.ORDER_TYPES, ["settingsGroup", "orderTypes"]],
  [NavigationPath.VEHICLES, ["settingsGroup", "vehicles"]],
  [NavigationPath.DRIVERS, ["settingsGroup", "drivers"]],
  [NavigationPath.OPERATORS, ["settingsGroup", "operators"]],
  [NavigationPath.CANCELLATION_REASONS, ["settingsGroup", "cancellationReasons"]],
  [NavigationPath.VALIDATOR_TYPES, ["settingsGroup", "validatorTypes"]],
  [NavigationPath.NOT_CONFIRMED_USERS, ["settingsGroup", "notConfirmedUsers"]],
  [NavigationPath.ADMINS, ["settingsGroup", "admins"]],
  [NavigationPath.REPORT_LIST, ["reportsGroup", "reportList"]],
  [NavigationPath.STORE_LIST, ["storeGroup", "storeList"]],
  [NavigationPath.INTERALSTORE_LIST, ["storeGroup", "internalStoreList"]],
  [NavigationPath.STORE_DOCS_LIST, ["storeGroup", "storeDocsList"]],
  [NavigationPath.CONTAINERS_LIST, ["storeGroup", "containersList"]],
  [NavigationPath.STORE_MAP, ["storeGroup", "storeMap"]],
  [NavigationPath.UNACTIVE_USERS, ["clientUsers", "inactiveClients"]],
  [NavigationPath.UNACTIVE_PICKUP_POINTS, ["clientsGroup", "receptionPlaces", "inactivePickupPoints"]],
]);

const BCrumb: React.FC = () => {
  const { t } = useTranslation("admin");
  const location = useLocation();
  const history = useHistory();

  const handleClick = (ev?: React.MouseEvent<HTMLElement>, item?: IBreadcrumbItem) => {
    if (item && ev) {
      ev.preventDefault();
      history.push(`${item.key}`);
    }
  };

  const root: IBreadcrumbItem = { text: t("nav.dashboard") as string, key: NavigationPath.HOME as string, onClick: handleClick };

  const keys = breadcrumbKeyMap.get(location.pathname);
  const pathItems: IBreadcrumbItem[] = keys
    ? keys.map((k) => ({ text: t(`nav.${k}`) as string, key: k }))
    : [];

  return <Breadcrumb items={[root, ...pathItems]} styles={breadcrumbS} maxDisplayedItems={4} />;
};

export default BCrumb;
